export enum DonorActivityType {
    DonorAddress,
    DonorContactMethod,
    Gift,
    RecurringGift,
    AuditLog
}
